var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPawn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 351,
    viewBox: "0 0 351 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.059 0.313354C78.3939 0.313354 0.0561523 78.6511 0.0561523 175.316C0.0561523 271.982 78.3939 350.313 175.059 350.313C271.724 350.313 350.056 271.976 350.056 175.316C350.056 78.6569 271.707 0.313354 175.059 0.313354ZM175.059 309.712C100.814 309.712 40.6573 249.544 40.6573 175.316C40.6573 101.088 100.831 40.9145 175.059 40.9145C249.287 40.9145 309.455 101.088 309.455 175.316C309.455 249.544 249.287 309.712 175.059 309.712Z",
    fill: "#B9B3B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.665 249.919C290.867 208.717 290.867 141.916 249.665 100.713C208.463 59.5114 141.661 59.5114 100.459 100.713C59.2568 141.916 59.2568 208.717 100.459 249.919C141.661 291.121 208.463 291.121 249.665 249.919Z",
    fill: "#B9B3B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white",
    transform: "translate(0.0561523 0.313354)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPawn);
export default __webpack_public_path__ + "static/media/ico-pawn.de3c13946c6a9acfc25a397a115bc965.svg";
export { ForwardRef as ReactComponent };